<template>
  <div id="badgeContats">
      <v-container grid-list-md fluid class="pt-0">
        <v-card-title>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search by Date / Family / Source"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-card class="mt-1">
          <v-data-table
            :headers="headers"
            :items="BadgeContact"
            :search="search"
            class="pf-data-table"
            :pagination.sync="pagination"
          >
            <template v-slot:items="props">
              <td>{{ props.item.dateFormate }}</td>
              <td>{{ props.item.account ? props.item.account.name : '--' }}</td>
              <td>{{ props.item.contact_name }}</td>
              <td>{{ props.item.source }}{{ props.item.ip ? ('/' + props.item.ip) : '' }}</td>
              <td width="230">{{ props.item.message }}</td>
              <td width="180">{{ props.item.phone ? props.item.phone : '--'}}</td>
              <td>{{ props.item.email }}</td>
              <td>{{ props.item.contact_preference }}</td>
              <td>{{ props.item.follow_up }}</td>
              <td align="right">
                <v-btn icon class="ma-0" v-on:click="deleteItem(props.item);">
                <v-icon size="22" class="pf-icon-delete">delete_outline</v-icon>
              </v-btn>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-container>
  </div>
</template>

<script>
/* global session store config  */
import swal from 'sweetalert2';
import { getCollection, formatDate, update } from '../../helpers/helpers';
import { mapGetters } from 'vuex';

// This lists all the countries and allow to edit them.
export default {
  name: 'adminBadgeContacts',
  data: () => ({
    entity: 'BadgeContact',
    search: '',
    headers: [
      { text: 'Date', width: '150px', value: 'dateFormate', align: 'left' },
      { text: 'Family', value: 'account.name', align: 'left' },
      { text: 'Contact', value: 'contact_name', align: 'left' },
      { text: 'Source/IP', value: 'source', align: 'left' },
      { text: 'Message', value: 'message', align: 'left' },
      { text: 'Phone', value: 'phone', align: 'left' },
      { text: 'Email', value: 'email', align: 'left' },
      { text: 'Preference', value: 'contact_preference', align: 'left' },
      { text: 'Follow Up', value: 'follow_up', align: 'left' },
      { text: '', sortable: false },
    ],
    pagination: {
      rowsPerPage: config.dom.rowsPerPage,
      sortBy: ''
    },  
  }),
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  computed: {
    ...mapGetters(['Agency']),
    BadgeContact: {
      get () {
        return store.state.BadgeContact;
      },
      set (value) {
        store.commit('setBadgeContact', value);
      }
    }
  },
  created () {
    this.initialize();
  },
  methods: {
    formatDateMethod (date, format = 'MM/DD/YYYY') {
      return formatDate(date, format);
    },
    // @vuese
    // Used to fetch the badge Contact list if not already exists
    async initialize () {
      if (!this.BadgeContact.length) {
        let where = { 'agency': this.Agency.id };
        let sort = { createdAt: -1 };
        let { error, data } = await getCollection(this.entity, true, 0, '', where, null, null, sort);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.BadgeContact = data.filter(contact => contact.deleted_status === false).map(contact => ({ ...contact, dateFormate: this.formatDateMethod(contact.date, 'MM/DD/YYYY') }));
          }
        }
      }
    },
    deleteItem (item) {
      swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          (async () => {
            let familyName = item.account.name;
            delete item.dateFormate;
            item.deleted_status = true;
            item.account = item.account.id;
            item.agency = item.agency.id;
            let { error, data, status } = await update(this.entity, item, item.id);
            if (error) {
              console.log('error', error);
            } else {
              const index = this.BadgeContact.indexOf(item);
              this.BadgeContact.splice(index, 1);
              swal.fire(
                'Deleted!',
                'Badge Contact"' + familyName + '" has been deleted.',
                'success'
              );
            }
          })();
        }
      });
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/BadgeContacts/agencyList.vue